import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getBusinessAuditTrailsUrl } from './apiUrls';
import { BusinessAuditTrail } from './types';

export function getBusinessAuditTrails(params: any): Promise<{ data: BusinessAuditTrail[]; meta: MetaApiResponse }> {
  return http.get(getBusinessAuditTrailsUrl(), params);
}
